<template>

	<div class="container page">

		<div class="header">
			<div class="nav-bar van-nav-bar van-hairline--bottom">
				<div class="van-nav-bar__content">

					<div class="van-nav-bar__left" @click="back()">
						<i class="van-icon van-icon-arrow-left" style="color: rgb(255, 255, 255);"></i>
					</div>

					<div class="van-nav-bar__title van-ellipsis">{{$t('recharge.recharge')}}</div>
					<div class="van-nav-bar__right" @click="torecharge">
						<span class="nav-right">{{$t('recharge.Charging_record')}}</span>
					</div>
				</div>
			</div>

			<div class="info">
				<p class="title"> {{ $t("recharge.curr_balance") }} </p>
				<p class="value">{{userInfo.money}}</p>
			</div>

			<div class="content recharge">
				<form class="van-form">
					<div class="form-item">
						<div class="form-item-title">{{ $t("recharge.input_money") }}
						</div>
						<div>
							<div class="van-cell van-field" style="font-size: 15px;">
								<div class="van-cell__value van-cell__value--alone van-field__value">
									<div class="van-field__body"><input type="text" v-model="money" name="money"
											:placeholder="$t('recharge.input_money')" class="van-field__control"></div>
								</div>
							</div>
						</div>
					</div>
					<div class="form-item">
						<div style="margin: 16px;">
							<div @click="onSubmit"
								class="van-button van-button--info van-button--normal van-button--block van-button--round"
								style="background: linear-gradient(30deg, #7d76ef, #d63f8c); border: none;">
								<div class="van-button__content"><span
										class="van-button__text">{{$t('recharge.next')}}</span></div>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>

		<!-- <div class="header">
			<van-nav-bar :title="$t('recharge.recharge')" class="nav-bar">
				<template #left>
					<van-icon name="arrow-left" color="#fff" @click="back()" />
				</template>
			</van-nav-bar>
			
			<div class="info">
				<p class="title">
					{{ $t("recharge.curr_balance") }}({{ $t("reservation.unit") }})
				</p>
				<p class="value">{{ this.balance }}</p>
			</div>
			
			<div class="content recharge">
				<van-form @submit="onSubmit">
					<div class="form-item">
						<div class="form-item-title">{{ $t("recharge.input_money") }}</div>
						<div style="height: 65px">
							<van-field v-model="money" name="money" label="MXN"
								:placeholder="$t('recharge.input_money')" />
						</div>
					</div>
					<div class="form-item">
						<div class="form-item-title">{{ $t("recharge.pay_way") }}</div>
						<div>
							<van-radio-group v-model="pay_way">
								<van-radio name="Mexicopay">MexicoPay</van-radio>
								<van-radio name="2">OpplePay</van-radio>
							</van-radio-group>
						</div>
						<div style="margin: 16px">
							<van-button round block type="info" native-type="submit">下一步</van-button>
						</div>
					</div>
				</van-form>
			</div>
		</div> -->
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Form
	} from "vant";
	import {
		Field
	} from "vant";
	import {
		RadioGroup,
		Radio
	} from "vant";
	Vue.use(Form).use(Field).use(RadioGroup).use(Radio);
	export default {
		data() {
			return {
				userInfo: {},
				balance: 0,
				pay_way: "Mexicopay",
				win_money: 0,
				money: "",
				personalreport: {},
			};
		},
		
		mounted() {
			
			this.balance = this.$route.params.balance;
			
		},
		
		methods: {

			torecharge() {
				this.$router.push({
					path: "/RechargeRecord"
				});
			},

			back() {
				return window.history.back();
			},

			//拉起支付
			onSubmit() {
				const money = this.money;
				if (money <= 0) {
					this.$toast(this.$t("reservation.money_err"));
					return;
				}
				this.$router.push({
					path: "/Channel"
				});
				// this.$http({
				// 	method: "post",
				// 	data: {
				// 		pay_way: this.pay_way,
				// 		money: money,
				// 	},
				// 	url: "recharge",
				// }).then((res) => {
				// 	console.log(res);
				// 	if (res.code === 200) {
				// 		window.location.href = res.data.pay_url;
				// 		//   this.personalreport = res.data;
				// 		//   this.win_money =
				// 		//     this.personalreport.win_money - this.personalreport.play_money;
				// 	} else if (res.code === 401) {
				// 		this.$toast(res.msg);
				// 	}
				// });
			},

			getPersonalreport() {
				this.$http({
					method: "get",
					url: "user_get_personalreport",
				}).then((res) => {
					if (res.code === 200) {
						this.personalreport = res.data;
						this.win_money =
							this.personalreport.win_money - this.personalreport.play_money;
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				});
			},
		},
		created() {
			if (!localStorage.getItem("token")) {
				this.$router.push({
					path: "/Login"
				});
			} else {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 200) {
						this.userInfo = res.data;
						console.log(this.userInfo);
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
				// this.getPersonalreport();
			}
		},
	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.nav-bar {
		background: none;
	}

	.container .header {
		background: linear-gradient(30deg, #7d76ef, #d63f8c);
	}

	.recharge {
		padding: 10px 8px;
	}

	.van-cell {
		line-height: 65px !important;
	}

	.van-button {
		height: 87px !important;
	}

	.van-button__text {
		color: #fff !important;
	}

	/deep/.van-radio__icon {
		font-size: 30px !important;
	}

	/deep/.van-radio__label {
		margin-left: 25px !important;
		font-size: 35px !important;
	}

	/deep/.van-radio {
		height: 65px !important;
	}

	.form-item {
		margin-top: 40px;
	}

	.form-item-title {
		font-size: 36px;
		font-weight: bold;
		color: #999;
		margin-bottom: 20px;
	}

	.recharge span {
		font-size: 4vw;
		color: #868686;
		font-weight: 500;
	}

	.container .header .info {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin: 10px 20px 20px;
		padding: 28px 20px;
		border-radius: 18px;
		background: rgba(255, 255, 255, 0.14);
		box-shadow: 0 10px 28px rgba(0, 0, 0, 0.16);
		border: 1px solid rgba(255, 255, 255, 0.18);
	}

	.container .header .info .title {
		font-size: 25px;
		color: #e5e5e5;
	}

	.container .header .info .value {
		margin: 10px auto;
		color: #fff;
		font-size: 50px;
		border-bottom: 1px solid #fff;
	}

	.container .header .info .tip {
		font-size: 30px;
		color: #e5e5e5;
	}

	.container .content {
		flex: 1;
		margin: 0 20px 24px;
		padding: 24px 20px;
		background: #fff;
		border-radius: 18px;
		box-shadow: 0 10px 28px rgba(79, 43, 138, 0.22), 0 4px 12px rgba(0, 0, 0, 0.12);
	}

	.container .content .van-cell {
		border-radius: 12px;
		overflow: hidden;
		box-shadow: 0 4px 14px rgba(79, 43, 138, 0.1);
	}
</style>